import React, { Component } from 'react';
import { withStyles, withWidth } from '@material-ui/core';
import ReactImageMagnify from 'react-image-magnify';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import discountImage from '../../utils/discountImage';
import ProductImageFail from '../../images/ProductImageFail.png';

const styles = theme => ({
  root: {
    padding: theme.spacing(1)
  },
  gallery: {
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  controls: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  thumb: {
    boxShadow: '0 3px 15px 0 rgba(0, 0, 0, 0.1)',
    margin: theme.spacing(0, 1, 1, 0),
    width: '75px'
  },
  discountImage: {
    position: 'absolute',
    zIndex: 1,
    width: '100px !important',
    height: '100px !important',
    right: '-20px'
  }
});

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: 0
    };
  }

  render() {
    const { classes, width } = this.props;
    const match = width === 'sm' || width === 'xs';

    const discountOfferImage = discountImage(this.props.product);

    return (
      <div className={classes.gallery}>
        {discountOfferImage !== null && (
          <img
            src={discountOfferImage}
            alt="cucarda"
            className={classes.discountImage}
          />
        )}
        <div className={classes.controls}>
          {this.props.images.map((image, index) => (
            <img
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              role="presentation"
              style={
                this.state.selectedItem === index
                  ? {
                      boxShadow: 'none',
                      border: '2px solid #000'
                    }
                  : {
                      cursor: 'pointer'
                    }
              }
              className={classes.thumb}
              src={
                image
                  ? image.default_small || image.product_small
                  : ProductImageFail
              }
              alt={
                image
                  ? image.default_small || image.product_small
                  : ProductImageFail
              }
              onClick={() => this.setState({ selectedItem: index })}
            />
          ))}
        </div>
        <Carousel
          width={match ? '300px' : '480px'}
          className={classes.carousel}
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          selectedItem={this.state.selectedItem}
        >
          {this.props.images.map(image => (
            <div
              key={
                image
                  ? image.default_small || image.product_small
                  : ProductImageFail
              }
            >
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: 'Wristwatch by Ted Baker London',
                    isFluidWidth: true,
                    src: image
                      ? image.default_big || image.product_big
                      : ProductImageFail
                  },
                  largeImage: {
                    src: image
                      ? image.default_big || image.original
                      : ProductImageFail,
                    width: 480 * 2.5,
                    height: 562 * 2.5
                  },
                  enlargedImagePosition: 'over'
                }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    );
  }
}

export default withWidth()(withStyles(styles)(Gallery));
